import { ConvertorFnsType } from "../types";
import { Account } from "../../../../../../../../../../../../services/cloudchipr.api";

export const accountValueGenerator: ConvertorFnsType = (key, resource) => {
  const value = resource?.[key] as Account;
  return value?.provider_account_name ?? value?.provider_account_id ?? "";
};
